// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ProgramImport } from './routes/program'
import { Route as EmailImport } from './routes/email'
import { Route as BrandStyleImport } from './routes/brand-style'
import { Route as IndexImport } from './routes/index'
import { Route as VipTierIndexImport } from './routes/vip-tier/index'
import { Route as TestIndexImport } from './routes/test/index'
import { Route as LanguageIndexImport } from './routes/language/index'
import { Route as IntegrationIndexImport } from './routes/integration/index'
import { Route as GuidanceIndexImport } from './routes/guidance/index'
import { Route as CustomersIndexImport } from './routes/customers/index'
import { Route as BrandStyleIndexImport } from './routes/brand-style/index'
import { Route as BillingIndexImport } from './routes/billing/index'
import { Route as SettingsFeedbackImport } from './routes/settings/feedback'
import { Route as SettingsEmailImport } from './routes/settings/email'
import { Route as RuleYoutubeImport } from './routes/rule/youtube'
import { Route as RuleVisitWebsiteImport } from './routes/rule/visit-website'
import { Route as RuleTwitterImport } from './routes/rule/twitter'
import { Route as RuleTikTokImport } from './routes/rule/tik-tok'
import { Route as RuleSubscribeImport } from './routes/rule/subscribe'
import { Route as RuleSignUpImport } from './routes/rule/sign-up'
import { Route as RuleReviewImport } from './routes/rule/review'
import { Route as RuleOrderImport } from './routes/rule/order'
import { Route as RuleInstagramImport } from './routes/rule/instagram'
import { Route as RuleFacebookImport } from './routes/rule/facebook'
import { Route as RuleBirthdayImport } from './routes/rule/birthday'
import { Route as ReferralCouponPointsImport } from './routes/referral-coupon/points'
import { Route as ReferralCouponPercentageImport } from './routes/referral-coupon/percentage'
import { Route as ReferralCouponFreeShippingImport } from './routes/referral-coupon/free-shipping'
import { Route as ReferralCouponFreeProductImport } from './routes/referral-coupon/free-product'
import { Route as ReferralCouponAmountImport } from './routes/referral-coupon/amount'
import { Route as ProgramVipImport } from './routes/program/vip'
import { Route as ProgramPopUpImport } from './routes/program/pop-up'
import { Route as ProgramLimitedTimeOffersImport } from './routes/program/limited-time-offers'
import { Route as ProgramActivityImport } from './routes/program/activity'
import { Route as PopupIncreaseRewardImport } from './routes/popup/increase-reward'
import { Route as PopupIncreasePointsImport } from './routes/popup/increase-points'
import { Route as PopupIncreaseMemberImport } from './routes/popup/increase-member'
import { Route as PopupDesignImport } from './routes/popup/design'
import { Route as MarketingEventsIdImport } from './routes/marketing-events/$id'
import { Route as IntegrationWilldeskImport } from './routes/integration/willdesk'
import { Route as IntegrationTrustooImport } from './routes/integration/trustoo'
import { Route as IntegrationKlaviyoImport } from './routes/integration/klaviyo'
import { Route as IntegrationJudgeMeImport } from './routes/integration/judge-me'
import { Route as EmailVipAchievedImport } from './routes/email/vip-achieved'
import { Route as EmailRewardWarningImport } from './routes/email/reward-warning'
import { Route as EmailRewardRedeemImport } from './routes/email/reward-redeem'
import { Route as EmailRewardLastChanceImport } from './routes/email/reward-last-chance'
import { Route as EmailReferPointsImport } from './routes/email/refer-points'
import { Route as EmailReferCouponImport } from './routes/email/refer-coupon'
import { Route as EmailPointsWarningImport } from './routes/email/points-warning'
import { Route as EmailPointsLastChanceImport } from './routes/email/points-last-chance'
import { Route as EmailPointsEarnImport } from './routes/email/points-earn'
import { Route as EmailDesignImport } from './routes/email/design'
import { Route as EmailBirthdayRewardImport } from './routes/email/birthday-reward'
import { Route as CouponPosPercentageImport } from './routes/coupon/pos-percentage'
import { Route as CouponPosAmountImport } from './routes/coupon/pos-amount'
import { Route as CouponPercentageImport } from './routes/coupon/percentage'
import { Route as CouponFreeShippingImport } from './routes/coupon/free-shipping'
import { Route as CouponFreeProductImport } from './routes/coupon/free-product'
import { Route as CouponAmountImport } from './routes/coupon/amount'
import { Route as BrandStyleWidgetPanelImport } from './routes/brand-style/widget-panel'
import { Route as BrandStyleTranslationImport } from './routes/brand-style/translation'
import { Route as BrandStyleGrowthToolsImport } from './routes/brand-style/growth-tools'
import { Route as ActivityTypeImport } from './routes/activity/$type'
import { Route as GuidanceBillingIndexImport } from './routes/guidance/billing/index'

// Create Virtual Routes

const SettingsLazyImport = createFileRoute('/settings')()
const PopupLazyImport = createFileRoute('/popup')()
const AllWaysRedeemLazyImport = createFileRoute('/all-ways-redeem')()
const AllWaysEarnLazyImport = createFileRoute('/all-ways-earn')()
const AllEventsLazyImport = createFileRoute('/all-events')()
const SettingsIndexLazyImport = createFileRoute('/settings/')()
const ProgramIndexLazyImport = createFileRoute('/program/')()
const AnalyticsIndexLazyImport = createFileRoute('/analytics/')()
const VipCouponPercentageLazyImport = createFileRoute(
  '/vip-coupon/percentage',
)()
const VipCouponFreeShippingLazyImport = createFileRoute(
  '/vip-coupon/free-shipping',
)()
const VipCouponFreeProductLazyImport = createFileRoute(
  '/vip-coupon/free-product',
)()
const VipCouponAmountLazyImport = createFileRoute('/vip-coupon/amount')()
const SettingsRewardLazyImport = createFileRoute('/settings/reward')()
const SettingsOrdersLazyImport = createFileRoute('/settings/orders')()
const SettingsImportLazyImport = createFileRoute('/settings/import')()
const SettingsHelpDocLazyImport = createFileRoute('/settings/help-doc')()
const ProgramReferralsLazyImport = createFileRoute('/program/referrals')()
const ProgramEmailLazyImport = createFileRoute('/program/email')()
const PlaygroundIconsLazyImport = createFileRoute('/playground/icons')()
const PlatformCalendlyLazyImport = createFileRoute('/platform/calendly')()
const IntegrationShopifyFlowLazyImport = createFileRoute(
  '/integration/shopify-flow',
)()
const CustomersAdjustCustomersLazyImport = createFileRoute(
  '/customers/adjust-customers',
)()
const AnalyticsRankRewardLazyImport = createFileRoute(
  '/analytics/rank-reward',
)()
const AnalyticsRankReferralLazyImport = createFileRoute(
  '/analytics/rank-referral',
)()
const AnalyticsRankEarnLazyImport = createFileRoute('/analytics/rank-earn')()
const MarketingEventsIdIndexLazyImport = createFileRoute(
  '/marketing-events/$id/',
)()
const CustomersRidIndexLazyImport = createFileRoute('/customers/$rid/')()
const MarketingEventsIdCouponLazyImport = createFileRoute(
  '/marketing-events/$id/coupon',
)()
const CustomersRidAdjustVipLazyImport = createFileRoute(
  '/customers/$rid/adjust-vip',
)()

// Create/Update Routes

const SettingsLazyRoute = SettingsLazyImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))

const PopupLazyRoute = PopupLazyImport.update({
  path: '/popup',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/popup.lazy').then((d) => d.Route))

const AllWaysRedeemLazyRoute = AllWaysRedeemLazyImport.update({
  path: '/all-ways-redeem',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/all-ways-redeem.lazy').then((d) => d.Route),
)

const AllWaysEarnLazyRoute = AllWaysEarnLazyImport.update({
  path: '/all-ways-earn',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/all-ways-earn.lazy').then((d) => d.Route))

const AllEventsLazyRoute = AllEventsLazyImport.update({
  path: '/all-events',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/all-events.lazy').then((d) => d.Route))

const ProgramRoute = ProgramImport.update({
  path: '/program',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/program.lazy').then((d) => d.Route))

const EmailRoute = EmailImport.update({
  path: '/email',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/email.lazy').then((d) => d.Route))

const BrandStyleRoute = BrandStyleImport.update({
  path: '/brand-style',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/brand-style.lazy').then((d) => d.Route))

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsIndexLazyRoute = SettingsIndexLazyImport.update({
  path: '/',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)

const ProgramIndexLazyRoute = ProgramIndexLazyImport.update({
  path: '/',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() => import('./routes/program/index.lazy').then((d) => d.Route))

const AnalyticsIndexLazyRoute = AnalyticsIndexLazyImport.update({
  path: '/analytics/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/analytics/index.lazy').then((d) => d.Route),
)

const VipTierIndexRoute = VipTierIndexImport.update({
  path: '/vip-tier/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vip-tier/index.lazy').then((d) => d.Route),
)

const TestIndexRoute = TestIndexImport.update({
  path: '/test/',
  getParentRoute: () => rootRoute,
} as any)

const LanguageIndexRoute = LanguageIndexImport.update({
  path: '/language/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/language/index.lazy').then((d) => d.Route),
)

const IntegrationIndexRoute = IntegrationIndexImport.update({
  path: '/integration/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/integration/index.lazy').then((d) => d.Route),
)

const GuidanceIndexRoute = GuidanceIndexImport.update({
  path: '/guidance/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/guidance/index.lazy').then((d) => d.Route),
)

const CustomersIndexRoute = CustomersIndexImport.update({
  path: '/customers/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/customers/index.lazy').then((d) => d.Route),
)

const BrandStyleIndexRoute = BrandStyleIndexImport.update({
  path: '/',
  getParentRoute: () => BrandStyleRoute,
} as any).lazy(() =>
  import('./routes/brand-style/index.lazy').then((d) => d.Route),
)

const BillingIndexRoute = BillingIndexImport.update({
  path: '/billing/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/billing/index.lazy').then((d) => d.Route))

const VipCouponPercentageLazyRoute = VipCouponPercentageLazyImport.update({
  path: '/vip-coupon/percentage',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vip-coupon/percentage.lazy').then((d) => d.Route),
)

const VipCouponFreeShippingLazyRoute = VipCouponFreeShippingLazyImport.update({
  path: '/vip-coupon/free-shipping',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vip-coupon/free-shipping.lazy').then((d) => d.Route),
)

const VipCouponFreeProductLazyRoute = VipCouponFreeProductLazyImport.update({
  path: '/vip-coupon/free-product',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vip-coupon/free-product.lazy').then((d) => d.Route),
)

const VipCouponAmountLazyRoute = VipCouponAmountLazyImport.update({
  path: '/vip-coupon/amount',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vip-coupon/amount.lazy').then((d) => d.Route),
)

const SettingsRewardLazyRoute = SettingsRewardLazyImport.update({
  path: '/reward',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/reward.lazy').then((d) => d.Route),
)

const SettingsOrdersLazyRoute = SettingsOrdersLazyImport.update({
  path: '/orders',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/orders.lazy').then((d) => d.Route),
)

const SettingsImportLazyRoute = SettingsImportLazyImport.update({
  path: '/import',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/import.lazy').then((d) => d.Route),
)

const SettingsHelpDocLazyRoute = SettingsHelpDocLazyImport.update({
  path: '/help-doc',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/help-doc.lazy').then((d) => d.Route),
)

const ProgramReferralsLazyRoute = ProgramReferralsLazyImport.update({
  path: '/referrals',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() =>
  import('./routes/program/referrals.lazy').then((d) => d.Route),
)

const ProgramEmailLazyRoute = ProgramEmailLazyImport.update({
  path: '/email',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() => import('./routes/program/email.lazy').then((d) => d.Route))

const PlaygroundIconsLazyRoute = PlaygroundIconsLazyImport.update({
  path: '/playground/icons',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/playground/icons.lazy').then((d) => d.Route),
)

const PlatformCalendlyLazyRoute = PlatformCalendlyLazyImport.update({
  path: '/platform/calendly',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/platform/calendly.lazy').then((d) => d.Route),
)

const IntegrationShopifyFlowLazyRoute = IntegrationShopifyFlowLazyImport.update(
  {
    path: '/integration/shopify-flow',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/integration/shopify-flow.lazy').then((d) => d.Route),
)

const CustomersAdjustCustomersLazyRoute =
  CustomersAdjustCustomersLazyImport.update({
    path: '/customers/adjust-customers',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/customers/adjust-customers.lazy').then((d) => d.Route),
  )

const AnalyticsRankRewardLazyRoute = AnalyticsRankRewardLazyImport.update({
  path: '/analytics/rank-reward',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/analytics/rank-reward.lazy').then((d) => d.Route),
)

const AnalyticsRankReferralLazyRoute = AnalyticsRankReferralLazyImport.update({
  path: '/analytics/rank-referral',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/analytics/rank-referral.lazy').then((d) => d.Route),
)

const AnalyticsRankEarnLazyRoute = AnalyticsRankEarnLazyImport.update({
  path: '/analytics/rank-earn',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/analytics/rank-earn.lazy').then((d) => d.Route),
)

const SettingsFeedbackRoute = SettingsFeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/feedback.lazy').then((d) => d.Route),
)

const SettingsEmailRoute = SettingsEmailImport.update({
  path: '/email',
  getParentRoute: () => SettingsLazyRoute,
} as any).lazy(() =>
  import('./routes/settings/email.lazy').then((d) => d.Route),
)

const RuleYoutubeRoute = RuleYoutubeImport.update({
  path: '/rule/youtube',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/youtube.lazy').then((d) => d.Route))

const RuleVisitWebsiteRoute = RuleVisitWebsiteImport.update({
  path: '/rule/visit-website',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/rule/visit-website.lazy').then((d) => d.Route),
)

const RuleTwitterRoute = RuleTwitterImport.update({
  path: '/rule/twitter',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/twitter.lazy').then((d) => d.Route))

const RuleTikTokRoute = RuleTikTokImport.update({
  path: '/rule/tik-tok',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/tik-tok.lazy').then((d) => d.Route))

const RuleSubscribeRoute = RuleSubscribeImport.update({
  path: '/rule/subscribe',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/rule/subscribe.lazy').then((d) => d.Route),
)

const RuleSignUpRoute = RuleSignUpImport.update({
  path: '/rule/sign-up',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/sign-up.lazy').then((d) => d.Route))

const RuleReviewRoute = RuleReviewImport.update({
  path: '/rule/review',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/review.lazy').then((d) => d.Route))

const RuleOrderRoute = RuleOrderImport.update({
  path: '/rule/order',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/order.lazy').then((d) => d.Route))

const RuleInstagramRoute = RuleInstagramImport.update({
  path: '/rule/instagram',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/rule/instagram.lazy').then((d) => d.Route),
)

const RuleFacebookRoute = RuleFacebookImport.update({
  path: '/rule/facebook',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/facebook.lazy').then((d) => d.Route))

const RuleBirthdayRoute = RuleBirthdayImport.update({
  path: '/rule/birthday',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rule/birthday.lazy').then((d) => d.Route))

const ReferralCouponPointsRoute = ReferralCouponPointsImport.update({
  path: '/referral-coupon/points',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/referral-coupon/points.lazy').then((d) => d.Route),
)

const ReferralCouponPercentageRoute = ReferralCouponPercentageImport.update({
  path: '/referral-coupon/percentage',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/referral-coupon/percentage.lazy').then((d) => d.Route),
)

const ReferralCouponFreeShippingRoute = ReferralCouponFreeShippingImport.update(
  {
    path: '/referral-coupon/free-shipping',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/referral-coupon/free-shipping.lazy').then((d) => d.Route),
)

const ReferralCouponFreeProductRoute = ReferralCouponFreeProductImport.update({
  path: '/referral-coupon/free-product',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/referral-coupon/free-product.lazy').then((d) => d.Route),
)

const ReferralCouponAmountRoute = ReferralCouponAmountImport.update({
  path: '/referral-coupon/amount',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/referral-coupon/amount.lazy').then((d) => d.Route),
)

const ProgramVipRoute = ProgramVipImport.update({
  path: '/vip',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() => import('./routes/program/vip.lazy').then((d) => d.Route))

const ProgramPopUpRoute = ProgramPopUpImport.update({
  path: '/pop-up',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() =>
  import('./routes/program/pop-up.lazy').then((d) => d.Route),
)

const ProgramLimitedTimeOffersRoute = ProgramLimitedTimeOffersImport.update({
  path: '/limited-time-offers',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() =>
  import('./routes/program/limited-time-offers.lazy').then((d) => d.Route),
)

const ProgramActivityRoute = ProgramActivityImport.update({
  path: '/activity',
  getParentRoute: () => ProgramRoute,
} as any).lazy(() =>
  import('./routes/program/activity.lazy').then((d) => d.Route),
)

const PopupIncreaseRewardRoute = PopupIncreaseRewardImport.update({
  path: '/increase-reward',
  getParentRoute: () => PopupLazyRoute,
} as any).lazy(() =>
  import('./routes/popup/increase-reward.lazy').then((d) => d.Route),
)

const PopupIncreasePointsRoute = PopupIncreasePointsImport.update({
  path: '/increase-points',
  getParentRoute: () => PopupLazyRoute,
} as any).lazy(() =>
  import('./routes/popup/increase-points.lazy').then((d) => d.Route),
)

const PopupIncreaseMemberRoute = PopupIncreaseMemberImport.update({
  path: '/increase-member',
  getParentRoute: () => PopupLazyRoute,
} as any).lazy(() =>
  import('./routes/popup/increase-member.lazy').then((d) => d.Route),
)

const PopupDesignRoute = PopupDesignImport.update({
  path: '/design',
  getParentRoute: () => PopupLazyRoute,
} as any).lazy(() => import('./routes/popup/design.lazy').then((d) => d.Route))

const MarketingEventsIdRoute = MarketingEventsIdImport.update({
  path: '/marketing-events/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/marketing-events/$id.lazy').then((d) => d.Route),
)

const IntegrationWilldeskRoute = IntegrationWilldeskImport.update({
  path: '/integration/willdesk',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/integration/willdesk.lazy').then((d) => d.Route),
)

const IntegrationTrustooRoute = IntegrationTrustooImport.update({
  path: '/integration/trustoo',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/integration/trustoo.lazy').then((d) => d.Route),
)

const IntegrationKlaviyoRoute = IntegrationKlaviyoImport.update({
  path: '/integration/klaviyo',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/integration/klaviyo.lazy').then((d) => d.Route),
)

const IntegrationJudgeMeRoute = IntegrationJudgeMeImport.update({
  path: '/integration/judge-me',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/integration/judge-me.lazy').then((d) => d.Route),
)

const EmailVipAchievedRoute = EmailVipAchievedImport.update({
  path: '/vip-achieved',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/vip-achieved.lazy').then((d) => d.Route),
)

const EmailRewardWarningRoute = EmailRewardWarningImport.update({
  path: '/reward-warning',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/reward-warning.lazy').then((d) => d.Route),
)

const EmailRewardRedeemRoute = EmailRewardRedeemImport.update({
  path: '/reward-redeem',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/reward-redeem.lazy').then((d) => d.Route),
)

const EmailRewardLastChanceRoute = EmailRewardLastChanceImport.update({
  path: '/reward-last-chance',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/reward-last-chance.lazy').then((d) => d.Route),
)

const EmailReferPointsRoute = EmailReferPointsImport.update({
  path: '/refer-points',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/refer-points.lazy').then((d) => d.Route),
)

const EmailReferCouponRoute = EmailReferCouponImport.update({
  path: '/refer-coupon',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/refer-coupon.lazy').then((d) => d.Route),
)

const EmailPointsWarningRoute = EmailPointsWarningImport.update({
  path: '/points-warning',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/points-warning.lazy').then((d) => d.Route),
)

const EmailPointsLastChanceRoute = EmailPointsLastChanceImport.update({
  path: '/points-last-chance',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/points-last-chance.lazy').then((d) => d.Route),
)

const EmailPointsEarnRoute = EmailPointsEarnImport.update({
  path: '/points-earn',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/points-earn.lazy').then((d) => d.Route),
)

const EmailDesignRoute = EmailDesignImport.update({
  path: '/design',
  getParentRoute: () => EmailRoute,
} as any).lazy(() => import('./routes/email/design.lazy').then((d) => d.Route))

const EmailBirthdayRewardRoute = EmailBirthdayRewardImport.update({
  path: '/birthday-reward',
  getParentRoute: () => EmailRoute,
} as any).lazy(() =>
  import('./routes/email/birthday-reward.lazy').then((d) => d.Route),
)

const CouponPosPercentageRoute = CouponPosPercentageImport.update({
  path: '/coupon/pos-percentage',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/coupon/pos-percentage.lazy').then((d) => d.Route),
)

const CouponPosAmountRoute = CouponPosAmountImport.update({
  path: '/coupon/pos-amount',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/coupon/pos-amount.lazy').then((d) => d.Route),
)

const CouponPercentageRoute = CouponPercentageImport.update({
  path: '/coupon/percentage',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/coupon/percentage.lazy').then((d) => d.Route),
)

const CouponFreeShippingRoute = CouponFreeShippingImport.update({
  path: '/coupon/free-shipping',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/coupon/free-shipping.lazy').then((d) => d.Route),
)

const CouponFreeProductRoute = CouponFreeProductImport.update({
  path: '/coupon/free-product',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/coupon/free-product.lazy').then((d) => d.Route),
)

const CouponAmountRoute = CouponAmountImport.update({
  path: '/coupon/amount',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/coupon/amount.lazy').then((d) => d.Route))

const BrandStyleWidgetPanelRoute = BrandStyleWidgetPanelImport.update({
  path: '/widget-panel',
  getParentRoute: () => BrandStyleRoute,
} as any).lazy(() =>
  import('./routes/brand-style/widget-panel.lazy').then((d) => d.Route),
)

const BrandStyleTranslationRoute = BrandStyleTranslationImport.update({
  path: '/translation',
  getParentRoute: () => BrandStyleRoute,
} as any).lazy(() =>
  import('./routes/brand-style/translation.lazy').then((d) => d.Route),
)

const BrandStyleGrowthToolsRoute = BrandStyleGrowthToolsImport.update({
  path: '/growth-tools',
  getParentRoute: () => BrandStyleRoute,
} as any).lazy(() =>
  import('./routes/brand-style/growth-tools.lazy').then((d) => d.Route),
)

const ActivityTypeRoute = ActivityTypeImport.update({
  path: '/activity/$type',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/activity/$type.lazy').then((d) => d.Route),
)

const MarketingEventsIdIndexLazyRoute = MarketingEventsIdIndexLazyImport.update(
  {
    path: '/',
    getParentRoute: () => MarketingEventsIdRoute,
  } as any,
).lazy(() =>
  import('./routes/marketing-events/$id/index.lazy').then((d) => d.Route),
)

const CustomersRidIndexLazyRoute = CustomersRidIndexLazyImport.update({
  path: '/customers/$rid/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/customers/$rid/index.lazy').then((d) => d.Route),
)

const GuidanceBillingIndexRoute = GuidanceBillingIndexImport.update({
  path: '/guidance/billing/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/guidance/billing/index.lazy').then((d) => d.Route),
)

const MarketingEventsIdCouponLazyRoute =
  MarketingEventsIdCouponLazyImport.update({
    path: '/coupon',
    getParentRoute: () => MarketingEventsIdRoute,
  } as any).lazy(() =>
    import('./routes/marketing-events/$id/coupon.lazy').then((d) => d.Route),
  )

const CustomersRidAdjustVipLazyRoute = CustomersRidAdjustVipLazyImport.update({
  path: '/customers/$rid/adjust-vip',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/customers/$rid/adjust-vip.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/brand-style': {
      preLoaderRoute: typeof BrandStyleImport
      parentRoute: typeof rootRoute
    }
    '/email': {
      preLoaderRoute: typeof EmailImport
      parentRoute: typeof rootRoute
    }
    '/program': {
      preLoaderRoute: typeof ProgramImport
      parentRoute: typeof rootRoute
    }
    '/all-events': {
      preLoaderRoute: typeof AllEventsLazyImport
      parentRoute: typeof rootRoute
    }
    '/all-ways-earn': {
      preLoaderRoute: typeof AllWaysEarnLazyImport
      parentRoute: typeof rootRoute
    }
    '/all-ways-redeem': {
      preLoaderRoute: typeof AllWaysRedeemLazyImport
      parentRoute: typeof rootRoute
    }
    '/popup': {
      preLoaderRoute: typeof PopupLazyImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      preLoaderRoute: typeof SettingsLazyImport
      parentRoute: typeof rootRoute
    }
    '/activity/$type': {
      preLoaderRoute: typeof ActivityTypeImport
      parentRoute: typeof rootRoute
    }
    '/brand-style/growth-tools': {
      preLoaderRoute: typeof BrandStyleGrowthToolsImport
      parentRoute: typeof BrandStyleImport
    }
    '/brand-style/translation': {
      preLoaderRoute: typeof BrandStyleTranslationImport
      parentRoute: typeof BrandStyleImport
    }
    '/brand-style/widget-panel': {
      preLoaderRoute: typeof BrandStyleWidgetPanelImport
      parentRoute: typeof BrandStyleImport
    }
    '/coupon/amount': {
      preLoaderRoute: typeof CouponAmountImport
      parentRoute: typeof rootRoute
    }
    '/coupon/free-product': {
      preLoaderRoute: typeof CouponFreeProductImport
      parentRoute: typeof rootRoute
    }
    '/coupon/free-shipping': {
      preLoaderRoute: typeof CouponFreeShippingImport
      parentRoute: typeof rootRoute
    }
    '/coupon/percentage': {
      preLoaderRoute: typeof CouponPercentageImport
      parentRoute: typeof rootRoute
    }
    '/coupon/pos-amount': {
      preLoaderRoute: typeof CouponPosAmountImport
      parentRoute: typeof rootRoute
    }
    '/coupon/pos-percentage': {
      preLoaderRoute: typeof CouponPosPercentageImport
      parentRoute: typeof rootRoute
    }
    '/email/birthday-reward': {
      preLoaderRoute: typeof EmailBirthdayRewardImport
      parentRoute: typeof EmailImport
    }
    '/email/design': {
      preLoaderRoute: typeof EmailDesignImport
      parentRoute: typeof EmailImport
    }
    '/email/points-earn': {
      preLoaderRoute: typeof EmailPointsEarnImport
      parentRoute: typeof EmailImport
    }
    '/email/points-last-chance': {
      preLoaderRoute: typeof EmailPointsLastChanceImport
      parentRoute: typeof EmailImport
    }
    '/email/points-warning': {
      preLoaderRoute: typeof EmailPointsWarningImport
      parentRoute: typeof EmailImport
    }
    '/email/refer-coupon': {
      preLoaderRoute: typeof EmailReferCouponImport
      parentRoute: typeof EmailImport
    }
    '/email/refer-points': {
      preLoaderRoute: typeof EmailReferPointsImport
      parentRoute: typeof EmailImport
    }
    '/email/reward-last-chance': {
      preLoaderRoute: typeof EmailRewardLastChanceImport
      parentRoute: typeof EmailImport
    }
    '/email/reward-redeem': {
      preLoaderRoute: typeof EmailRewardRedeemImport
      parentRoute: typeof EmailImport
    }
    '/email/reward-warning': {
      preLoaderRoute: typeof EmailRewardWarningImport
      parentRoute: typeof EmailImport
    }
    '/email/vip-achieved': {
      preLoaderRoute: typeof EmailVipAchievedImport
      parentRoute: typeof EmailImport
    }
    '/integration/judge-me': {
      preLoaderRoute: typeof IntegrationJudgeMeImport
      parentRoute: typeof rootRoute
    }
    '/integration/klaviyo': {
      preLoaderRoute: typeof IntegrationKlaviyoImport
      parentRoute: typeof rootRoute
    }
    '/integration/trustoo': {
      preLoaderRoute: typeof IntegrationTrustooImport
      parentRoute: typeof rootRoute
    }
    '/integration/willdesk': {
      preLoaderRoute: typeof IntegrationWilldeskImport
      parentRoute: typeof rootRoute
    }
    '/marketing-events/$id': {
      preLoaderRoute: typeof MarketingEventsIdImport
      parentRoute: typeof rootRoute
    }
    '/popup/design': {
      preLoaderRoute: typeof PopupDesignImport
      parentRoute: typeof PopupLazyImport
    }
    '/popup/increase-member': {
      preLoaderRoute: typeof PopupIncreaseMemberImport
      parentRoute: typeof PopupLazyImport
    }
    '/popup/increase-points': {
      preLoaderRoute: typeof PopupIncreasePointsImport
      parentRoute: typeof PopupLazyImport
    }
    '/popup/increase-reward': {
      preLoaderRoute: typeof PopupIncreaseRewardImport
      parentRoute: typeof PopupLazyImport
    }
    '/program/activity': {
      preLoaderRoute: typeof ProgramActivityImport
      parentRoute: typeof ProgramImport
    }
    '/program/limited-time-offers': {
      preLoaderRoute: typeof ProgramLimitedTimeOffersImport
      parentRoute: typeof ProgramImport
    }
    '/program/pop-up': {
      preLoaderRoute: typeof ProgramPopUpImport
      parentRoute: typeof ProgramImport
    }
    '/program/vip': {
      preLoaderRoute: typeof ProgramVipImport
      parentRoute: typeof ProgramImport
    }
    '/referral-coupon/amount': {
      preLoaderRoute: typeof ReferralCouponAmountImport
      parentRoute: typeof rootRoute
    }
    '/referral-coupon/free-product': {
      preLoaderRoute: typeof ReferralCouponFreeProductImport
      parentRoute: typeof rootRoute
    }
    '/referral-coupon/free-shipping': {
      preLoaderRoute: typeof ReferralCouponFreeShippingImport
      parentRoute: typeof rootRoute
    }
    '/referral-coupon/percentage': {
      preLoaderRoute: typeof ReferralCouponPercentageImport
      parentRoute: typeof rootRoute
    }
    '/referral-coupon/points': {
      preLoaderRoute: typeof ReferralCouponPointsImport
      parentRoute: typeof rootRoute
    }
    '/rule/birthday': {
      preLoaderRoute: typeof RuleBirthdayImport
      parentRoute: typeof rootRoute
    }
    '/rule/facebook': {
      preLoaderRoute: typeof RuleFacebookImport
      parentRoute: typeof rootRoute
    }
    '/rule/instagram': {
      preLoaderRoute: typeof RuleInstagramImport
      parentRoute: typeof rootRoute
    }
    '/rule/order': {
      preLoaderRoute: typeof RuleOrderImport
      parentRoute: typeof rootRoute
    }
    '/rule/review': {
      preLoaderRoute: typeof RuleReviewImport
      parentRoute: typeof rootRoute
    }
    '/rule/sign-up': {
      preLoaderRoute: typeof RuleSignUpImport
      parentRoute: typeof rootRoute
    }
    '/rule/subscribe': {
      preLoaderRoute: typeof RuleSubscribeImport
      parentRoute: typeof rootRoute
    }
    '/rule/tik-tok': {
      preLoaderRoute: typeof RuleTikTokImport
      parentRoute: typeof rootRoute
    }
    '/rule/twitter': {
      preLoaderRoute: typeof RuleTwitterImport
      parentRoute: typeof rootRoute
    }
    '/rule/visit-website': {
      preLoaderRoute: typeof RuleVisitWebsiteImport
      parentRoute: typeof rootRoute
    }
    '/rule/youtube': {
      preLoaderRoute: typeof RuleYoutubeImport
      parentRoute: typeof rootRoute
    }
    '/settings/email': {
      preLoaderRoute: typeof SettingsEmailImport
      parentRoute: typeof SettingsLazyImport
    }
    '/settings/feedback': {
      preLoaderRoute: typeof SettingsFeedbackImport
      parentRoute: typeof SettingsLazyImport
    }
    '/analytics/rank-earn': {
      preLoaderRoute: typeof AnalyticsRankEarnLazyImport
      parentRoute: typeof rootRoute
    }
    '/analytics/rank-referral': {
      preLoaderRoute: typeof AnalyticsRankReferralLazyImport
      parentRoute: typeof rootRoute
    }
    '/analytics/rank-reward': {
      preLoaderRoute: typeof AnalyticsRankRewardLazyImport
      parentRoute: typeof rootRoute
    }
    '/customers/adjust-customers': {
      preLoaderRoute: typeof CustomersAdjustCustomersLazyImport
      parentRoute: typeof rootRoute
    }
    '/integration/shopify-flow': {
      preLoaderRoute: typeof IntegrationShopifyFlowLazyImport
      parentRoute: typeof rootRoute
    }
    '/platform/calendly': {
      preLoaderRoute: typeof PlatformCalendlyLazyImport
      parentRoute: typeof rootRoute
    }
    '/playground/icons': {
      preLoaderRoute: typeof PlaygroundIconsLazyImport
      parentRoute: typeof rootRoute
    }
    '/program/email': {
      preLoaderRoute: typeof ProgramEmailLazyImport
      parentRoute: typeof ProgramImport
    }
    '/program/referrals': {
      preLoaderRoute: typeof ProgramReferralsLazyImport
      parentRoute: typeof ProgramImport
    }
    '/settings/help-doc': {
      preLoaderRoute: typeof SettingsHelpDocLazyImport
      parentRoute: typeof SettingsLazyImport
    }
    '/settings/import': {
      preLoaderRoute: typeof SettingsImportLazyImport
      parentRoute: typeof SettingsLazyImport
    }
    '/settings/orders': {
      preLoaderRoute: typeof SettingsOrdersLazyImport
      parentRoute: typeof SettingsLazyImport
    }
    '/settings/reward': {
      preLoaderRoute: typeof SettingsRewardLazyImport
      parentRoute: typeof SettingsLazyImport
    }
    '/vip-coupon/amount': {
      preLoaderRoute: typeof VipCouponAmountLazyImport
      parentRoute: typeof rootRoute
    }
    '/vip-coupon/free-product': {
      preLoaderRoute: typeof VipCouponFreeProductLazyImport
      parentRoute: typeof rootRoute
    }
    '/vip-coupon/free-shipping': {
      preLoaderRoute: typeof VipCouponFreeShippingLazyImport
      parentRoute: typeof rootRoute
    }
    '/vip-coupon/percentage': {
      preLoaderRoute: typeof VipCouponPercentageLazyImport
      parentRoute: typeof rootRoute
    }
    '/billing/': {
      preLoaderRoute: typeof BillingIndexImport
      parentRoute: typeof rootRoute
    }
    '/brand-style/': {
      preLoaderRoute: typeof BrandStyleIndexImport
      parentRoute: typeof BrandStyleImport
    }
    '/customers/': {
      preLoaderRoute: typeof CustomersIndexImport
      parentRoute: typeof rootRoute
    }
    '/guidance/': {
      preLoaderRoute: typeof GuidanceIndexImport
      parentRoute: typeof rootRoute
    }
    '/integration/': {
      preLoaderRoute: typeof IntegrationIndexImport
      parentRoute: typeof rootRoute
    }
    '/language/': {
      preLoaderRoute: typeof LanguageIndexImport
      parentRoute: typeof rootRoute
    }
    '/test/': {
      preLoaderRoute: typeof TestIndexImport
      parentRoute: typeof rootRoute
    }
    '/vip-tier/': {
      preLoaderRoute: typeof VipTierIndexImport
      parentRoute: typeof rootRoute
    }
    '/analytics/': {
      preLoaderRoute: typeof AnalyticsIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/program/': {
      preLoaderRoute: typeof ProgramIndexLazyImport
      parentRoute: typeof ProgramImport
    }
    '/settings/': {
      preLoaderRoute: typeof SettingsIndexLazyImport
      parentRoute: typeof SettingsLazyImport
    }
    '/customers/$rid/adjust-vip': {
      preLoaderRoute: typeof CustomersRidAdjustVipLazyImport
      parentRoute: typeof rootRoute
    }
    '/marketing-events/$id/coupon': {
      preLoaderRoute: typeof MarketingEventsIdCouponLazyImport
      parentRoute: typeof MarketingEventsIdImport
    }
    '/guidance/billing/': {
      preLoaderRoute: typeof GuidanceBillingIndexImport
      parentRoute: typeof rootRoute
    }
    '/customers/$rid/': {
      preLoaderRoute: typeof CustomersRidIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/marketing-events/$id/': {
      preLoaderRoute: typeof MarketingEventsIdIndexLazyImport
      parentRoute: typeof MarketingEventsIdImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  BrandStyleRoute.addChildren([
    BrandStyleGrowthToolsRoute,
    BrandStyleTranslationRoute,
    BrandStyleWidgetPanelRoute,
    BrandStyleIndexRoute,
  ]),
  EmailRoute.addChildren([
    EmailBirthdayRewardRoute,
    EmailDesignRoute,
    EmailPointsEarnRoute,
    EmailPointsLastChanceRoute,
    EmailPointsWarningRoute,
    EmailReferCouponRoute,
    EmailReferPointsRoute,
    EmailRewardLastChanceRoute,
    EmailRewardRedeemRoute,
    EmailRewardWarningRoute,
    EmailVipAchievedRoute,
  ]),
  ProgramRoute.addChildren([
    ProgramActivityRoute,
    ProgramLimitedTimeOffersRoute,
    ProgramPopUpRoute,
    ProgramVipRoute,
    ProgramEmailLazyRoute,
    ProgramReferralsLazyRoute,
    ProgramIndexLazyRoute,
  ]),
  AllEventsLazyRoute,
  AllWaysEarnLazyRoute,
  AllWaysRedeemLazyRoute,
  PopupLazyRoute.addChildren([
    PopupDesignRoute,
    PopupIncreaseMemberRoute,
    PopupIncreasePointsRoute,
    PopupIncreaseRewardRoute,
  ]),
  SettingsLazyRoute.addChildren([
    SettingsEmailRoute,
    SettingsFeedbackRoute,
    SettingsHelpDocLazyRoute,
    SettingsImportLazyRoute,
    SettingsOrdersLazyRoute,
    SettingsRewardLazyRoute,
    SettingsIndexLazyRoute,
  ]),
  ActivityTypeRoute,
  CouponAmountRoute,
  CouponFreeProductRoute,
  CouponFreeShippingRoute,
  CouponPercentageRoute,
  CouponPosAmountRoute,
  CouponPosPercentageRoute,
  IntegrationJudgeMeRoute,
  IntegrationKlaviyoRoute,
  IntegrationTrustooRoute,
  IntegrationWilldeskRoute,
  MarketingEventsIdRoute.addChildren([
    MarketingEventsIdCouponLazyRoute,
    MarketingEventsIdIndexLazyRoute,
  ]),
  ReferralCouponAmountRoute,
  ReferralCouponFreeProductRoute,
  ReferralCouponFreeShippingRoute,
  ReferralCouponPercentageRoute,
  ReferralCouponPointsRoute,
  RuleBirthdayRoute,
  RuleFacebookRoute,
  RuleInstagramRoute,
  RuleOrderRoute,
  RuleReviewRoute,
  RuleSignUpRoute,
  RuleSubscribeRoute,
  RuleTikTokRoute,
  RuleTwitterRoute,
  RuleVisitWebsiteRoute,
  RuleYoutubeRoute,
  AnalyticsRankEarnLazyRoute,
  AnalyticsRankReferralLazyRoute,
  AnalyticsRankRewardLazyRoute,
  CustomersAdjustCustomersLazyRoute,
  IntegrationShopifyFlowLazyRoute,
  PlatformCalendlyLazyRoute,
  PlaygroundIconsLazyRoute,
  VipCouponAmountLazyRoute,
  VipCouponFreeProductLazyRoute,
  VipCouponFreeShippingLazyRoute,
  VipCouponPercentageLazyRoute,
  BillingIndexRoute,
  CustomersIndexRoute,
  GuidanceIndexRoute,
  IntegrationIndexRoute,
  LanguageIndexRoute,
  TestIndexRoute,
  VipTierIndexRoute,
  AnalyticsIndexLazyRoute,
  CustomersRidAdjustVipLazyRoute,
  GuidanceBillingIndexRoute,
  CustomersRidIndexLazyRoute,
])
